/**
 * Created by vladislav on 5/8/2024
 */

const ScoreTracker = function () {
    this.score = 0;
    this.lastReport = 0;

    this.load();

    this.withDialog = connector.platform.oneOf(connector.INSTANT);
    this.levelUpOnly = connector.platform.oneOf(connector.SAMSUNG) && ["merge"].includes(cleverapps.config.type);

    if (this.withDialog && ["merge", "merge2"].includes(cleverapps.config.type)) {
        ScoreTracker.REPORT_TIMEOUT = cleverapps.parseInterval("2 days");
    } else if (connector.platform.oneOf(connector.YOUTUBE, connector.GAMESNACK)) {
        ScoreTracker.REPORT_TIMEOUT = 0;
    }
};

ScoreTracker.prototype.load = function () {
    let data = cleverapps.dataLoader.load(DataLoader.TYPES.SCORE);
    if (!data) {
        // compatability
        data = cleverapps.dataLoader.load(DataLoader.TYPES.INSTANT_TOURNAMENT);
    }
    if (data) {
        this.score = data.score || 0;
        this.lastReport = data.lastReport || 0;
    }
};

ScoreTracker.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.SCORE, {
        score: this.score,
        lastReport: this.lastReport
    });
};

ScoreTracker.prototype.calcScore = function () {
    let level = cleverapps.user.getLevel();

    if (!this.levelUpOnly) {
        level += cleverapps.user.getExp() / cleverapps.user.getExpThreshold();
    }

    return Math.round(level * 100);
};

ScoreTracker.prototype.setScore = function (score) {
    this.score = score;
    this.save();
};

ScoreTracker.prototype.needToReport = function () {
    if (Date.now() - this.lastReport < ScoreTracker.REPORT_TIMEOUT) {
        return false;
    }

    if (this.withDialog) {
        const level = cleverapps.user.getLevel();
        if (level < 5) {
            return false;
        }

        if (cleverapps.timeStart === undefined || Date.now() - cleverapps.timeStart < 60000) {
            return false;
        }

        const score = this.calcScore();

        let per = 10;
        if (level < 9) {
            per = 50;
        }

        if (score < (Math.floor(this.score / per) + 1) * per) {
            return false;
        }
    }

    return true;
};

ScoreTracker.prototype.report = cleverapps.accumulate(1000, function () {
    if (!cleverapps.platformLogic.reportScore) {
        return;
    }
    
    if (!connector.platform.isConnected()) {
        return;
    }

    if (!this.needToReport()) {
        return;
    }

    const score = this.calcScore();

    cleverapps.platformLogic.reportScore(score, (code) => {
        if (code === cleverapps.CODE_SUCCEED) {
            this.lastReport = Date.now();
            this.setScore(score);
        }
    });
});

ScoreTracker.REPORT_TIMEOUT = cleverapps.parseInterval("10 minutes");
